<!------------------------------------------------------------------------------
 File: BarListCheckinModule
 Created by keni.
 with: IntelliJ IDEA
 Date: 09/05/2018
 Time: 15:55
------------------------------------------------------------------------------->
<template>
    <div class="graph-list-wrapper">
        <!--graph-->
        <div class="row mb-4">
            <div class=" col-md-3 col-lg-3">
                <!--ACTION LINKS-->
                <nav class="nav-links pb-4">
                    <!--inline on mobile and stacked desktop-->
                    <div class="d-flex justify-content-between align-items-start d-md-block">

                        <baseNavListItem
                                class="pt-md-0 pt-2"
                                v-if="typeof edit_event_uri !== 'undefined' && edit_event_uri !== null"
                                direction="rtl"

                                :event_uri="edit_event_uri"
                                :icon="{
                                    content:'settings'
                                }"
                                content_small="Edit"
                                content_large="Event Details"
                        >
                        </baseNavListItem>
                        <baseNavListItem
                                class="px-0 py-2 p-md-2"
                                direction="rtl"

                                :event_uri="edit_tickets_uri"
                                :icon="{
                                    cls:'fa icon-tilt-ticket'
                                }"
                                content_small="Tickets"
                                content_large="Config"
                        >
                        </baseNavListItem>
                        <baseNavListItem
                                v-if="typeof edit_wastage_uri !== 'undefined' && edit_wastage_uri !== null"
                                class="px-0 py-2 p-md-2"
                                direction="rtl"

                                :event_uri="edit_wastage_uri"
                                :icon="{
                                    content:'warning'
                                }"
                                content_small="Wastage"
                        >
                        </baseNavListItem>
                        <baseNavListItem
                                v-if="typeof edit_vip_tickets_uri !== 'undefined' && edit_vip_tickets_uri !== null"
                                class="px-0 py-2 p-md-2"
                                direction="rtl"

                                :event_uri="edit_vip_tickets_uri"
                                :icon="{
                                    content:'group'
                                }"
                                content_small="Vip"
                                content_large="Tickets"
                        >
                        </baseNavListItem>
                    </div>

                    <!--<a class="nav-link" href="#"><i class="fa fa-link"></i> Create shareable link</a>-->
                </nav>
            </div>
            <div class="col-md-9 col-lg-9">
                <card-basic>
                    <component is="h3" slot="header" class="pl-0 pb-1 d-none d-md-block">
                        <span>{{title}}</span>
                    </component>
                    <component v-on:click="getCompiledData(true)" is="small" slot="sub-header" class="d-block" v-if="time_to_refresh !== ''">Refreshes @
                        {{time_to_refresh}}
                    </component>
                    <div v-if="first_load" class="graph-loader-wrapper">
                        <div class="loader"></div>
                    </div>
                    <bar-chart
                            v-show="!first_load"
                            :options="{responsive: true, maintainAspectRatio: false}"
                            :chart_dataset="compiledDataForChart"
                            :width="700"
                            :height="400"
                            @on_bar_click="select_entity"
                    ></bar-chart>
                </card-basic>
            </div>
        </div>
        <!--list-->
        <div class="row">
            <!--Stats-->
            <div class="col-md-3 col-lg-3">
                <card-basic>
                    <i v-if="selected_entity"
                       slot="close"
                       v-on:click="deselect_entity()"
                       class="cursor-pointer float-right fa fa-times pt-2 px-2 pb-0"
                    ></i>
                    <h6 v-if="selected_entity"
                        slot="header"
                        class="cursor-pointer h6-responsive p-0"
                    >
                        <span>{{selected_entity.label}}</span>
                    </h6>
                    <hr v-if="selected_entity">
                    <ul v-if="selected_entity" class="list-unstyled">
                        <li>
                            <!--Checked In-->
                            <!--<span class="badge badge-info badge-pill">{{selected_entity.check_in_count}}</span>-->

                            <BaseBadge
                                    :distribute="true"
                                    title="Checked In"
                                    cls="badge-info"
                            >
                                {{selected_entity.check_in_count}}
                            </BaseBadge>
                        </li>
                        <li>
                            <BaseBadge
                                    :distribute="true"
                                    title="Checked In %"
                                    cls="badge-info"
                            >
                                {{getPercentage(selected_entity.check_in_count,
                                selected_entity.sold_count)}}%
                            </BaseBadge>
                        </li>
                        <li>
                            <BaseBadge
                                    :distribute="true"
                                    title="Sales"
                                    cls="badge-info"
                            >
                                {{selected_entity.sold_count}}
                            </BaseBadge>
                        </li>
                        <li>
                            <BaseBadge
                                    :distribute="true"
                                    title="Allocated"
                                    cls="badge-info"
                            >
                                {{selected_entity.allocated_count}}
                            </BaseBadge>
                        </li>
                        <li>
                            <BaseBadge
                                    :distribute="true"
                                    title="Free spaces"
                                    cls="badge-info"
                            >
                                {{selected_entity.remaining_count}}
                            </BaseBadge>
                        </li>
                    </ul>

                    <h6 v-if="!selected_entity"
                        slot="header"
                        class="h6-responsive p-0"
                    >
                        Stats - <strong>ALL</strong>
                    </h6>
                    <hr v-if="!selected_entity">
                    <ul v-if="!selected_entity" class="list-unstyled">
                        <li>
                            <!--Checked In-->
                            <!--<span class="badge badge-info badge-pill">{{selected_entity.check_in_count}}</span>-->

                            <BaseBadge
                                    :distribute="true"
                                    title="Checked In"
                                    cls="badge-info"
                            >
                                {{check_in_total_count}}
                            </BaseBadge>
                        </li>
                        <li>
                            <BaseBadge
                                    :distribute="true"
                                    title="Checked In %"
                                    cls="badge-info"
                            >
                                {{getPercentage(check_in_total_count,
                                sales_total_count)}}%
                            </BaseBadge>
                        </li>
                        <li>
                            <BaseBadge
                                    :distribute="true"
                                    title="Sales"
                                    cls="badge-info"
                            >
                                {{sales_total_count}}
                            </BaseBadge>
                        </li>
                        <li>
                            <BaseBadge
                                    :distribute="true"
                                    title="Allocated"
                                    cls="badge-info"
                            >
                                {{allocated_total_count}}
                            </BaseBadge>
                        </li>
                        <li>
                            <BaseBadge
                                    :distribute="true"
                                    title="Free spaces"
                                    cls="badge-info"
                            >
                                {{remaining_total_count}}
                            </BaseBadge>
                        </li>
                    </ul>
                </card-basic>
            </div>

            <div class="col-md-9 col-lg-9">
                <div class="card">
                    <div class="card-header">
                        <div class=" d-flex justify-content-between align-items-center">
                            <!--stats sales title-->
                            <h4 class="m-0" v-if="selected_entity != null">{{selected_entity.label}} Sales</h4>
                            <h4 class="m-0" v-else>
                                All sales
                            </h4>
                            <div v-if="allow_export" class="d-flex  justify-content-end align-items-center">
                                <!--show export plates-->
                                <div>
                                    <div class="cursor-pointer font-weight-bold p-2 m-1"
                                         v-if="export_config.plates.loading_export == 0 && export_config.sales.loading_export <= 0"
                                         v-on:click="compileExportRecords('plates')"
                                    >
                                        <div class="d-flex justify-content-between align-items-center ">
                                            Plates
                                            <i class="cursor-pointer material-icons"
                                            >file_download</i>
                                        </div>
                                    </div>
                                    <!--show when compiling-->
                                    <div v-else-if="export_config.plates.loading_export == 1">
                                        Preparing Plates
                                    </div>
                                    <!--show when data is compiled and ready-->
                                    <div v-else-if="export_config.plates.loading_export == 2"
                                         class="d-flex justify-content-between align-items-center">
                                        <download-excel
                                                :name="event_name+'-'+export_config.plates.file_name + '.' + export_config.plates.file_type"
                                                :type="export_config.plates.data.type"
                                                :fields="export_config.plates.data.json_fields"
                                                :data="export_config.plates.data.json_data"
                                                class=""

                                        >
                                            <div class="btn btn-secondary"
                                                 v-on:click="export_config.plates.loading_export = 0"
                                            >
                                                <div class="d-flex  justify-content-between align-items-center ">
                                                    <span class="mr-2">Plates</span>
                                                    <i class="cursor-pointer material-icons"
                                                    >cloud_download</i>
                                                </div>

                                            </div>
                                        </download-excel>
                                    </div>
                                </div>
                                <!--show export sales breakdown-->
                                <div data-ref="show export sales breakdown">
                                    <!--show export button-->
                                    <div class="cursor-pointer font-weight-bold p-2 m-1"
                                         v-if="export_config.sales.loading_export == 0 && export_config.plates.loading_export <= 0"
                                         v-on:click="compileExportRecords('sales')"
                                    >
                                        <div class="d-flex  justify-content-between align-items-center ">
                                            <span>Sales</span>
                                            <i class="cursor-pointer material-icons"
                                            >file_download</i>
                                        </div>
                                    </div>
                                    <!--show when compiling-->
                                    <div v-else-if="export_config.sales.loading_export == 1">
                                        Preparing sales
                                    </div>
                                    <!--show when data is compiled and ready-->
                                    <div v-else-if="export_config.sales.loading_export == 2"
                                         class="d-flex justify-content-between align-items-center">
                                        <download-excel
                                                :name="event_name+'-'+export_config.sales.file_name + '.' + export_config.sales.file_type"
                                                :type="export_config.sales.data.type"
                                                :fields="export_config.sales.data.json_fields"
                                                :data="export_config.sales.data.json_data"
                                                class=""
                                        >
                                            <div class="btn btn-secondary"
                                                 v-on:click="export_config.sales.loading_export = 0"
                                            >
                                                <div class="d-flex  justify-content-between align-items-center ">
                                                    <span class="mr-2">Sales</span>
                                                    <i class="cursor-pointer material-icons"
                                                    >cloud_download</i>
                                                </div>
                                            </div>
                                        </download-excel>
                                    </div>
                                </div>
                                <div v-if="selected_entity" data-ref="show export all sales breakdown">
                                    <!--show export button-->
                                    <div class="cursor-pointer font-weight-bold p-2 m-1"
                                         v-if="export_config.all_sales.loading_export == 0 && export_config.plates.loading_export <= 0 && export_config.sales.loading_export <= 0"
                                         v-on:click="compileExportRecords('all_sales')"
                                    >
                                        <div class="d-flex  justify-content-between align-items-center ">
                                            <span>Customers</span>
                                            <i class="cursor-pointer material-icons"
                                            >file_download</i>
                                        </div>
                                    </div>
                                    <!--show when compiling-->
                                    <div v-else-if="export_config.all_sales.loading_export == 1">
                                        Preparing Customers
                                    </div>
                                    <!--show when data is compiled and ready-->
                                    <div v-else-if="export_config.all_sales.loading_export == 2"
                                         class="d-flex justify-content-between align-items-center">
                                        <download-excel
                                                :name="createFileNameForExport(event_name+'-'+selected_entity.label+'--'+export_config.all_sales.file_name )+'.' + export_config.all_sales.file_type"
                                                :type="export_config.all_sales.data.type"
                                                :fields="export_config.all_sales.data.json_fields"
                                                :data="export_config.all_sales.data.json_data"
                                                class=""
                                        >
                                            <div class="btn btn-secondary"
                                                 v-on:click="export_config.all_sales.loading_export = 0"
                                            >
                                                <div class="d-flex  justify-content-between align-items-center ">
                                                    <span class="mr-2">Customers</span>
                                                    <i class="cursor-pointer material-icons"
                                                    >cloud_download</i>
                                                </div>
                                            </div>
                                        </download-excel>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!--show the list-->
                    <div class="card-body py-1 card-body-min-height">
                        <bar-list-checkin-pagination-component
                            v-if="sale_contents_loaded"
                            :enable_search="enable_search"
                            :pagination="pagination"
                            :filter="filter"
                            :disable_button="pre_search_val.length < inputLengthBeforeSubmit"
                            :search_button="!auto_search"
                            @filter="setFilter"
                            @pageinate_event="paginatePage"
                            @search_event="searchEvent"
                            @close_search_event="closeSearch()"
                            @searchButton="executeSearch(pre_search_val)"
                        ></bar-list-checkin-pagination-component>

                        <!--Loading DATA-->
                        <transition name="fade">
                            <div v-if="loading_records" class="d-flex justify-content-center">
                                <div class="loader"></div>
                            </div>
                            <checkin-list
                                    :event_id="event_id"
                                    :sale_content_checkin_read_url="sale_content_checkin_read_url"
                                    :sale_content_checkin_post_url="sale_content_checkin_post_url"
                                v-else-if="sale_contents.length > 0"
                                :sale_contents="sale_contents"
                                :sale_reference_uri="sale_reference_uri"
                                :asset_read="asset_read"
                                :asset_delete="asset_delete"
                                :asset_store="asset_store"
                            ></checkin-list>

                            <div v-else class="d-flex justify-content-center">
                                <h4>No records</h4>
                            </div>
                        </transition>

                        <bar-list-checkin-pagination-component
                            v-if="sale_contents.length > 0 && !loading_records"
                            :enable_search="false"
                            :pagination="pagination"
                            @pageinate_event="paginatePage"
                            @search_event="findUser"
                            @close_search_event="closeSearch()"
                        ></bar-list-checkin-pagination-component>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import axios from 'axios';
    import {_} from 'underscore';
    import {uniqueId} from '../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds';

    import {truncate} from '../../../../../app/Shared/Resources/Assets/js/helpers/format.string';
    import {friendly} from '../../../../../app/Shared/Resources/Assets/js/helpers/strings';
    import JsonExcel from '../export/JsonExcel';
    import BarListCheckinPaginationComponent from "../navigation/BarListCheckinPaginationComponent";
    import CheckinList from "./CheckinList"; //https://github.com/jecovier/vue-json-excel
    Vue.component('baseNavListItem', require('../base/BaseNavListItem'));
    /** vue components **/
    Vue.component('plates', require('../../../../../app/Shared/Resources/Assets/js/components/Plates'));
    Vue.component('card-basic', require('../cards/CardBasic'));
    Vue.component('bar-chart', require('../charts/BarChart.vue'));
    // Vue.component('table-data', require('../tables/table'));
    Vue.component('simple-modal',
        require('../../../../../app/Shared/Resources/Assets/js/components/notifications/SimpleModal'));
    Vue.component('downloadExcel', JsonExcel);
    export default {
        name: 'bar-list-checkin-module',
        components: {CheckinList, BarListCheckinPaginationComponent},
        props: {
            event_id:Number,
            sale_content_checkin_read_url:String,
            sale_content_checkin_post_url:String,
            allow_export: Boolean,
            title: String,
            event_category: String,
            event_name: String,
            get_check_in_data_url: String,
            get_sales_data_for_tickets_url: String,
            edit_event_uri: String,
            edit_tickets_uri: String,
            edit_wastage_uri: String,
            edit_vip_tickets_uri: String,
            sale_reference_uri: String,
            asset_read: String,
            asset_store: String,
            asset_delete: String,
            tickets_array: Array,
            enable_search: {
                default: false,
                type: Boolean
            },
            auto_search: {
                default: false,
                type: Boolean
            }
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
            this.getCompiledData(false);
        },
        data() {
            return {
                time_to_refresh: '',
                single_ticket_only: false,
                export_config: {
                    all_sales: {
                        load_export: false,
                        loading_export: 0, // 0 not loading , 1 loading , 2 ready
                        file_name: 'export',
                        file_type: 'csv',
                        export_data: [],
                        fields: [
                            'type'
                        ],
                        data: {
                            type: 'csv',
                            json_fields: {
                                email: 'email',
                                date: 'date',
                                ticket: 'ticket',
                                type: 'category',
                                ticket_type: 'ticket_type',
                                season_ticket_name: 'season_ticket_name',
                                price_paid: 'price_paid_gbp',
                                // tickets will have a different price so we must group those into common paid
                                checked_in: 'units_checked_in'
                            },
                            json_data: [],
                            json_meta: [
                                [
                                    {
                                        'key': 'charset',
                                        'value': 'utf-8'
                                    }
                                ]
                            ]
                        }
                    },
                    sales: {
                        load_export: false,
                        loading_export: 0, // 0 not loading , 1 loading , 2 ready
                        file_name: 'export',
                        file_type: 'csv',
                        export_data: [],
                        fields: [
                            'type'
                        ],
                        data: {
                            type: 'csv',
                            json_fields: {
                                ticket: 'ticket',
                                type: 'category',
                                ticket_type: 'ticket_type',
                                price_paid: 'price_paid_gbp',
                                event_qty: 'event_qty',
                                // tickets will have a different price so we must group those into common paid
                                units_sold: 'units_sold',
                                checked_in: 'units_checked_in'
                            },
                            json_data: [],
                            json_meta: [
                                [
                                    {
                                        'key': 'charset',
                                        'value': 'utf-8'
                                    }
                                ]
                            ]
                        }
                    },
                    plates: {
                        load_export: false,
                        loading_export: 0, // 0 not loading , 1 loading , 2 ready
                        file_name: 'PlateList',
                        file_type: 'csv',
                        export_data: [],
                        fields: [
                            'Plate',
                            'Details',
                            'DataField1',
                            'DataField2',
                            'DataField3',
                            'Confidence',
                            'FirstDate',
                            'FirstTime',
                            'FirstParkingBay',
                            'FirstLocLat',
                            'FirstLocLong',
                            'FirstLocAcc',
                            'LastDate',
                            'LastTime',
                            'LastParkingBay',
                            'LastLocLat',
                            'LastLocLong',
                            'LastLocAcc',
                            'PermitExpiryDate'
                        ],
                        data: {
                            type: 'csv',
                            json_fields: {
                                Plate: 'Plate',
                                Details: 'Details',
                                DataField1: 'DataField1',
                                DataField2: 'DataField2',
                                DataField3: 'DataField3',
                                Confidence: 'Confidence',
                                FirstDate: 'FirstDate',
                                FirstTime: 'FirstTime',
                                FirstParkingBay: 'FirstParkingBay',
                                FirstLocLat: 'FirstLocLat',
                                FirstLocLong: 'FirstLocLong',
                                FirstLocAcc: 'FirstLocAcc',
                                LastDate: 'LastDate',
                                LastTime: 'LastTime',
                                LastParkingBay: 'LastParkingBay',
                                LastLocLat: 'LastLocLat',
                                LastLocLong: 'LastLocLong',
                                LastLocAcc: 'LastLocAcc',
                                PermitExpiryDate: 'PermitExpiryDate'
                            },
                            json_data: [],
                            json_meta: [
                                [
                                    {
                                        'key': 'charset',
                                        'value': 'utf-8'
                                    }
                                ]
                            ]
                        }
                    }
                },
                wastage_total_count: 0,
                sales_total_count: 0,
                check_in_total_count: 0,
                remaining_total_count: 0,
                allocated_total_count: 0,

                entities: [],
                selected_entity: null,
                sale_contents: [],
                sale_contents_loaded: false,
                filter: 'ref',
                loading_records: true,
                first_load: true,

                compiledDataForChart: {
                    labels: [],
                    datasets: []
                },
                inputDebounceTime: 600,
                search_val: '',
                pre_search_val: '',

                pagination: {
                    topId: uniqueId('rows-per-page'),
                    bottomId: uniqueId('rows-per-page'),
                    callback_name: 'pageinate_event',
                    numberOfPages: 0,
                    limit: 15,
                    start: 0,
                    end: 0,
                    page_length: 1,
                    current_page: 1
                }
            };
        },
        methods: {
            setFilter(val){
                this.filter = val;
            },
            findUser: _.debounce(function (val){
                let inputValue = val.trim();

                if (inputValue.length >= this.inputLengthBeforeSubmit) {
                    this.executeSearch(inputValue);
                }
            }, 600), //'this' is not accessible at this point
            searchEvent(val){
                if (this.auto_search) return this.findUser(val);
                this.pre_search_val = val;
            },
            executeSearch(val){
                this.search_val = val;
                console.log('find', val, 'this.inputDebounceTime', this.inputDebounceTime);
                this.resetPagination();
                this.loadSales();
            },
            closeSearch() {
                console.log('search closed');
                if (this.search_val.trim() !== ''){
                    this.search_val = '';
                    this.resetPagination();
                    this.loadSales();
                }
            },
            fetchTest(item) {
                console.log('fetchTest', 'test', item);
                return this;
            },
            log() {
                console.log(arguments);
            },
            resetPagination(){
                this.pagination.start = 0;
                this.pagination.end = 0;
                this.pagination.page_length = 1;
                this.pagination.current_page = 1;
            },
            compileExportSales(property) {

            },
            createFileNameForExport(filename) {
                return friendly(filename)
            },
            compileExportRecords(property) {

                let
                    _self = this,
                    tickets_array = [],
                    slug = property;

                _self.export_config[slug].load_export = !_self.export_config[slug].load_export;

                if (_self.export_config[slug].load_export === true) {
                    _self.export_config[slug].loading_export = 1;
                    if (_self.selected_entity === null) {
                        _self.entities.forEach(function (entity) {
                            tickets_array.push(entity.tickets_array);
                        });
                        tickets_array = _.flatten(tickets_array);
                    } else {
                        tickets_array = _self.selected_entity.tickets_array;
                    }

                    axios.post(_self.get_sales_data_for_tickets_url,
                        {
                            tickets_array: tickets_array,
                            length: false
                        })
                        .then(function (response) {
                            if (response.data.success) {
                                _self.export_config[slug].data.json_data = [];

                                if (slug === 'all_sales') {
                                    _self.export_config[slug].export_data = response.data.csv_data;
                                    let length = _self.export_config[slug].export_data.length;

                                    for (let i = 0; i < length; i++) {
                                        let record = _self.export_config[slug].export_data[i];

//                                        let json_item, ticket = record.ticket;
                                        let json_item;

                                        json_item = {
                                            email: record.email,
                                            date: record.created_at,
                                            ticket: record.title,
                                            type: _self.event_category,
                                            ticket_type: record.ticket_type,
                                            season_ticket_name: (record.ticket_group_id !== null)
                                                                ? record.season_ticket_title
                                                                : 'NA',
                                            price_paid: (record.price_paid > 0) ? record.price_paid / 100 : 0,
                                            // tickets will have a different price so we must group those into common paid
                                            // units_sold: 0,
                                            checked_in: (record.checked_in == 1)
                                                        ? true
                                                        : false
                                        };
                                        _self.export_config[slug].data.json_data.push(json_item);
                                    }


                                } else {
                                    /**
                                     * Return an array where the key is the ticket id
                                     */
                                    _self.export_config[slug].export_data = response.data.csv_sale_contents;
                                    let salesGroupedByTicket = _.groupBy(_self.export_config[slug].export_data,
                                        /**
                                         * @property sale.vip_reservation
                                         * @namespace sale
                                         **/
                                        function (sale) {
                                            if ( sale !== null) {
                                                // let ticketActive = sale.vip_reservation <= 0 && sale.status != 'cancelled';
                                                let ticketActive = sale.vip_reservation <= 0 && sale.status != 'cancelled';
                                                if (_self.single_ticket_only == true) {
                                                    ticketActive = ticketActive && sale.ticket.ticket_type == 'single';
                                                }
                                                //only add if its a single ticket
                                                return ticketActive ? sale.ticket_id : false;
                                            }
                                        });

                                    for (let saleItem in salesGroupedByTicket) {
                                        // prepare the row for insertion

                                        // this should be the row in the json_data
                                        let ticket = salesGroupedByTicket[saleItem],
                                            /**
                                             * group the sales by price paid
                                             *
                                             * returns a list of sales keyed as paid
                                             * @var {Object} ticketGroupedByPricePaid
                                             * @var {Array}[] ticketGroupedByPricePaid
                                             */
                                            ticketGroupedByPricePaid = _.groupBy(ticket, 'price_paid');
                                        // set up the record to be populated
                                        /**
                                         * Iterate the records which are now organised by the price paid for the ticket
                                         * */
                                        for (let ticketGroupedByPricePaidKey in ticketGroupedByPricePaid) {
                                            let priceGroups = ticketGroupedByPricePaid[ticketGroupedByPricePaidKey];
                                            let json_item;
                                            if (slug === 'sales') {
                                                json_item = {
                                                    type: _self.event_category,
                                                    ticket: _.first(ticket).ticket.title,
                                                    ticket_type: _.first(ticket).ticket.ticket_type,
                                                    event_qty: JSON.parse(_.first(ticket).ticket.events).length,
                                                    price_paid: 0,
                                                    // tickets will have a different price so we must group those into common paid
                                                    units_sold: 0,
                                                    checked_in: 0
                                                };
                                            } else {
                                                if (slug == 'plates') {
                                                    json_item = _self.export_config.plates.fields;
                                                } else {
                                                    json_item = null;
                                                }
                                            }
                                            /**
                                             * list each sale and test if it was refunded
                                             */
                                            for (let priceGroupKey in priceGroups) {
                                                /**
                                                 * @property refunds
                                                 * @property app_record
                                                 * @property user_assets_group.user_assets
                                                 * @property user_assets_group
                                                 * @namespace sale
                                                 * */
                                                let sale = priceGroups[priceGroupKey];

                                                if (sale.refunds.length > 0) {
                                                    console.error('refunds here ', sale);
                                                }
                                                // else {
                                                //
                                                // }
                                                // console.log('sale', 'sale',sale);
                                                // ticket was checked in
                                                if (slug == 'sales') {
                                                    if (sale.app_record !== null) {

                                                        // console.log('', 'sale.app_record', sale.app_record);
                                                        json_item.checked_in = ++json_item.checked_in;
                                                    }
                                                } else if (slug == 'plates') {
                                                    // get the users list of plates
                                                    // console.log('', 'sale.user_assets_group.user_assets.length ',sale.user_assets_group.user_assets.length );
                                                    if (sale.user_assets_group.user_assets.length > 0) {
                                                        for (
                                                            let i = 0;
                                                            i < sale.user_assets_group.user_assets.length;
                                                            i++
                                                        ) {
                                                            let userAsset = sale.user_assets_group.user_assets[i];
                                                            //console.log('sale', 'sale',sale);
                                                            //console.log('sale', 'userAsset', userAsset);
                                                            let eventsListStripWhiteSpace = sale.ticket.events.replace(/ /g, ''),
                                                                replaceComma = eventsListStripWhiteSpace.replace(/,/g, '|');

                                                            if (userAsset.type == 'plate' && sale.sale.user !== null) {
                                                                //console.log('userAsset', 'sale.sale.user',sale.sale.user);
                                                                _self.export_config[slug].data.json_data.push({
                                                                    Plate: userAsset.value,
                                                                    Details: sale.ticket.ticket_type,
                                                                    DataField1: sale.ticket_id,
                                                                    DataField2: replaceComma,
                                                                    DataField3: sale.sale.user.email,
                                                                    Confidence: '',
                                                                    FirstDate: '',
                                                                    FirstTime: '',
                                                                    FirstParkingBay: '',
                                                                    FirstLocLat: '',
                                                                    FirstLocLong: '',
                                                                    FirstLocAcc: '',
                                                                    LastDate: '',
                                                                    LastTime: '',
                                                                    LastParkingBay: '',
                                                                    LastLocLat: '',
                                                                    LastLocLong: '',
                                                                    LastLocAcc: '',
                                                                    PermitExpiryDate: ''
                                                                });

                                                            }

                                                        }
                                                    }

                                                }

                                                // console.log('axios', 'sale', sale);
                                            }

                                            // console.log('', 'ticketGroupedByPricePaidKey', ticketGroupedByPricePaidKey);
                                            if (slug === 'sales') {
                                                json_item.price_paid =
                                                    // json_item.price_paid +
                                                    parseInt(ticketGroupedByPricePaidKey) / 100;

                                                json_item.units_sold =
                                                    // json_item.units_sold +
                                                    priceGroups.length;

                                                // console.log('slug', slug, 'json_item', json_item);
                                                // console.log('', '_self.export_config[slug].data.json_data',_self.export_config[slug].data.json_data);

                                                _self.export_config[slug].data.json_data.push(json_item);
//console.log('', '_self.export_config[slug].data.json_data',_self.export_config[slug].data.json_data);
                                                //console.log('stage 1')
                                            }

                                        }
                                        // console.log('compileExportRecords.json_item', 'json_item',json_item);
                                        //console.log('stage 2')

                                        // console.log('', 'json_item', json_item);
                                        // console.log('', 'groupedByPricePaid', groupedByPricePaid);
                                    }
                                }


                                // set state to awaiting download trigger
                                _self.export_config[slug].loading_export = 2;
                            }
                        })
                        .catch(function (e) {
                            console.error('e', e);
                        });
                }
                // request for all if no entity is selected

            },
            getPercentage(a, b) {
                let result = parseFloat(a / b * 100).toFixed(2);
                return (
                           isNaN(result)
                       ) ? 0 : result;
            },

            select_entity(bar_data) {
                this.selected_entity = this.entities[bar_data.index];
                this.resetPagination();
                this.loadSales();
            },

            deselect_entity() {
                this.sale_contents = [];

                this.selected_entity = null;
                this.resetPagination();
                this.export_config.sales.loading_export = 0;
                this.export_config.plates.loading_export = 0;
                this.loadSales();
            },

            loadExportSales() {

            },
            loadSales() {
                let
                    _self = this,
                    tickets_array = _self.tickets_array;

                _self.loading_records = true;
                _self.export_config.sales.loading_export = 0;
                _self.export_config.plates.loading_export = 0;

                if (_self.selected_entity !== null) {
                    tickets_array = _self.selected_entity.tickets_array;
                }
                axios.post(_self.get_sales_data_for_tickets_url, {
                    tickets_array: tickets_array,
                    length: _self.pagination.limit,
                    page: _self.pagination.current_page,
                    find: _self.search_val,
                    filter: _self.filter
                })
                    .then(function (response) {
                        if (response.data.success) {
                            _self.loading_records = false;

                            /**
                             * @property last_page
                             * @namespace sale_contents
                             * */
                            _self.sale_contents = response.data.sale_contents.data || [];
                            _self.pagination.numberOfPages = response.data.sale_contents.last_page || 0;
                            _self.pagination.page_length = response.data.sale_contents.total || 0;

                            _self.pagination.start = response.data.sale_contents.from  ? response.data.sale_contents.from - 1 : -1;
                            _self.pagination.end = response.data.sale_contents.to ? response.data.sale_contents.to - 1 : 0;
                            _self.sale_contents_loaded = true;
                        }
                    });
            },

            //Compiling data
            getCompiledData(force) {
                let _self = this,
                    forceUpdate = false;
                //                console.log('getCompiledData', '_self.sale_reference_uri', _self.sale_reference_uri);
                if (typeof force === 'undefined' || force === null) {
                    forceUpdate = false;
                } else {
                    forceUpdate = force;
                }
                _self.check_in_total_count = 0;
                _self.sales_total_count = 0;
                _self.wastage_total_count = 0;
                _self.remaining_total_count = 0;
                _self.pagination.start = 0;


                //Let's preload sales with the supplied tickets array for the event
                _self.loadSales(_self.tickets_array);

                axios.get(_self.get_check_in_data_url, {
                    params: {
                        force: forceUpdate
                    }
                })

                    .then(function (response) {
                        if (response.data.success) {
                            let
                                _labels = [],
                                _check_in_dataset = [],
                                _sold_dataset = [],
                                _wastage_dataset = [],
                                _remaining_dataset = [];

                            _self.time_to_refresh = response.data.refresh_time;

                            /**
                             * @property entity.check_in_count
                             * @property entity.sold_count
                             * @property entity.wastage_count
                             * @property entity.remaining_count
                             * @property entity.allocated_count
                             * @namespace entity
                             */
                            response.data.entities.forEach(function (entity) {
                                // console.log('entity', 'entity', entity);
                                _labels.push(truncate(entity.label, 7));
                                _check_in_dataset.push(entity.check_in_count);
                                _sold_dataset.push(entity.sold_count);
                                _wastage_dataset.push(entity.wastage_count);
                                _remaining_dataset.push(entity.remaining_count);

                                _self.check_in_total_count += entity.check_in_count;
                                _self.sales_total_count += entity.sold_count;
                                _self.wastage_total_count += entity.wastage_count;
                                _self.remaining_total_count += entity.remaining_count;
                                _self.allocated_total_count += entity.allocated_count;

                                _self.entities.push(entity);
                            });

                            _self.first_load = false;

                            _self.compiledDataForChart = {
                                labels: _labels,
                                datasets: [
                                    {
                                        'label': 'checked in',
                                        'backgroundColor': '#00c600',
                                        'data': _check_in_dataset
                                    },
                                    {
                                        'label': 'sold',
                                        'backgroundColor': '#0045f8',
                                        'data': _sold_dataset
                                    },
                                    {
                                        'label': 'wastage',
                                        'backgroundColor': '#f80030',
                                        'data': _wastage_dataset
                                    },
                                    {
                                        'label': 'remaining',
                                        'backgroundColor': '#d8e5f8',
                                        'data': _remaining_dataset
                                    }
                                ]
                            };
                        }
                    });
            },

            //Pagination
            paginatePage(data) {
                // console.log('paginatePage', data);

                if (data.action === 'rows') {
                    if (this.pagination.limit != data.value) {
                        this.pagination.limit = data.value;
                        this.loadSales();
                    }
                } else if (data.action === 'next') {
                    if (data.value) {
                        //NEXT Page requested
                        if (this.pagination.current_page < this.pagination.numberOfPages) {
                            this.pagination.current_page++;
                            this.loadSales();
                        }
                    } else {
                        //PREV Page requested
                        if (this.pagination.current_page !== 1) {
                            this.pagination.current_page--;
                            this.loadSales();
                        }
                    }
                }
            },

        },
        watch: {},
        computed: {
            inputLengthBeforeSubmit() {
                if (this.filter === 'email'){
                    return 10;
                }
                else if (this.filter === 'ref'){
                    return 5;
                }
                else if (this.filter === 'last_name'){
                    return 5;
                }

                return 20;
            }
        }
    };
</script>

<style scoped>
    .card-body-min-height{
        min-height: 80vh;
    }
    .table-fixed {
        table-layout: fixed;
        overflow: hidden;
    }

    .loader {
        border: 8px solid #f3f3f3;
        border-radius: 50%;
        border-top: 8px solid #3498db;
        width: 60px;
        height: 60px;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
    }

    .graph-loader-wrapper {
        width: 100%;
        height: 415px; /* 400px from bar graph plus 15 px for legend*/
        display: flex;
        justify-content: center;
        align-items: center;
    }

    /* Safari */
    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/modules/BarListCheckinModule.vue?96fa234a